export default __webpack_public_path__ + "static/media/031-jolly-roger.2442e967.png";